import React, { Component } from 'react';
import ListView from '@bit/super-mario.yoshi.listview';
import { store } from '../../../redux/store';
import SecureAxiosClient from '../../../auth/secure_axios';
import getConfig from '../../../config';
import * as ChatActions from '../../../redux/actions/chat';
import './latest.css';

const LATEST_THREAD_DURATION_HRS = 180
const MAX_LATEST_THREAD_COUNT = 3;

class LatestThreads extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    let config = getConfig();
    let threadUrl = `${config.luigi.domain}${config.luigi.services.latest_thread}` + LATEST_THREAD_DURATION_HRS;
    new SecureAxiosClient().get(
      threadUrl,
      (responseCode, responseData) => {
        this.setState({ threads: responseData });
      }
    )

    // This should be done in a better way later.
    store.dispatch(ChatActions.setThemeImage({
      theme_image: null
    }));
  }

  render() {
    const list = this.state.threads || [];
    if (list.length === 0) return null;

    for (let i = 0; i < list.length; i++) {
      const thread = list[i];
      if (!thread) continue;
      thread.thread_url = `/thread/${thread.id}`;
    }

    const threads = [...list.slice(0, MAX_LATEST_THREAD_COUNT)].filter(t => t != null);

    return (
      <div className="homepage-latest-threads">
        <ListView
          heading="Latest threads"
          list={threads}
          pageUrl="/latest-thread"
        />
      </div>
    )
  }
}

export default LatestThreads;